export default __webpack_public_path__ + "static/media/about-us-base-with-text.746a2945.jpg";